import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box } from "@gemini/core";
import { FARBWELT_TOP_OFFSET } from "@/components/utilsComponents/farbwelt/constants";
import { useFarbwelt } from "@/hooks";
export const ContactCardWrapper = ({ children, testId, paddingTop, isFarbweltActive, }) => {
    const [scrollPosition, setScrollPosition] = useState(0);
    useEffect(() => {
        const handleScroll = () => {
            // eslint-disable-next-line no-restricted-globals
            setScrollPosition(window.scrollY);
        };
        // eslint-disable-next-line no-restricted-globals
        window.addEventListener("scroll", handleScroll);
        // eslint-disable-next-line no-restricted-globals
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    const topPosition = scrollPosition > FARBWELT_TOP_OFFSET && isFarbweltActive
        ? "calc(72px + 32px)" // header_height + expected offset
        : "spacing.32";
    return (_jsx(Box, { position: "sticky", top: topPosition, transitionDuration: "motionDuration.150", transitionTimingFunction: "motionEasing.linear", testId: testId, display: "flex", flexDirection: "column", alignItems: "flex-end", paddingTop: paddingTop, unsafe_className: "ContactCard", children: children }));
};
export const Card = ({ children }) => {
    const { isFarbweltActive } = useFarbwelt(); // FIXME temp fix to set a fixed height on the CC
    return (_jsx(Box, { display: "flex", flexDirection: "column", alignItems: "center", paddingHorizontal: {
            "breakpoint.base": "spacing.16",
            "breakpoint.xxl": "spacing.24",
            "breakpoint.xxxl": "spacing.32",
        }, paddingTop: {
            "breakpoint.base": "spacing.16",
            "breakpoint.xxl": "spacing.24",
            "breakpoint.xxxl": "spacing.32",
        }, paddingBottom: {
            "breakpoint.base": "spacing.24",
            "breakpoint.xxxl": "spacing.32",
        }, borderStyle: "solid", boxShadow: "shadow.16", borderRadius: "radius.16", borderColor: "color.border.constant.white", backgroundColor: "color.surface.constant.white.default", marginBottom: "spacing.64", width: "100%", zIndex: "zIndex.4", minHeight: {
            "breakpoint.lg": "345px",
            "breakpoint.xl": `calc(345px + ${isFarbweltActive ? "48px" : "0px"})`, // 48px = farbwelt banner height
            "breakpoint.xxl": `calc(360px + ${isFarbweltActive ? "48px" : "0px"})`, // 48px = farbwelt banner height
            "breakpoint.xxxl": `calc(460px + ${isFarbweltActive ? "48px" : "0px"})`, // 48px = farbwelt banner height
        }, children: children }));
};
export const ContactCardColumnWrapper = ({ children, testId, }) => {
    return (_jsx(Box, { position: "relative", gridColumn: {
            "breakpoint.lg": "col-start 9 / span 4",
            "breakpoint.xl": "col-start 9 / span 4",
            "breakpoint.xxl": "col-start 9 / span 3",
        }, height: "100%", display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "flex",
        }, flexDirection: "column", testId: testId, unsafe_className: "ContactCardColumn", children: children }));
};
